import * as client from './baseClient';

export const fetchUserPermissions = (userEmail) =>
  client.get(`/api/users/${userEmail}`);

export const changePassword = (userEmail, loggedInUserId) =>
  client.post(
    `/api/users/${userEmail}/change-password`,
    undefined,
    undefined,
    loggedInUserId
  );

export const getAllUsers = (loggedInUserId) =>
  client.get('/api/users', undefined, loggedInUserId);

export const createUser = (user, loggedInUserId) =>
  client.post('/api/users', user, undefined, loggedInUserId);

export const editUser = (user, loggedInUserId) =>
  client.put(`/api/users/${user.id}`, user, undefined, loggedInUserId);

export const checkIfUserIsRelatedToBranch = (payload) =>
  client.get(`/api/users/${payload.userId}/branch-exists/${payload.branchId}`);
